import { ListItem, OrderedList } from "@chakra-ui/react";
import { ReactNode } from "react";

export interface FaqItemProps {
  buttonTitle: string;
  panelContent: string | ReactNode;
}

export const returnFaqItems = (t: any): FaqItemProps[] => [
  {
    buttonTitle: t("quarantine"),
    panelContent: t("quarantineContent"),
  },
  {
    buttonTitle: t("howGetBusinessVisa"),
    panelContent: t("howGetBusinessVisaContent"),
  },
  //{
  //  buttonTitle: t("doUHaveSideEvents"),
  //  panelContent: t("doUHaveSideEventsContent"),
  //},

  {
    buttonTitle: t("howCanAccess"),
    panelContent: (
      <>
        {t.rich("howCanAccessContent", {
          parent: (children: any) => <OrderedList>{children}</OrderedList>,
          item: (children: any) => <ListItem>{children}</ListItem>,
        })}
      </>
    ),
  },

  {
    buttonTitle: t("whereIsTicket"),
    panelContent: t("whereIsTicketContent"),
  },
  {
    buttonTitle: t("howCanRefund"),
    panelContent: t("howCanRefundContent"),
  },
  {
    buttonTitle: t("howCanTransfer"),
    panelContent: t("howCanTransferContent"),
  },
];
